import type { FaireProductEntity } from "../../entity_types/product";

export const p_c268etmvtc: FaireProductEntity = {
  token: "p_c268etmvtc",
  type: "product",
  name: '(KG)SPHERE - MICA, GOLDEN 2-3.25"',
  brandToken: "b_b1k03395mh",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/bcbe35e7113a78a95d0a59d74721f2a02f8daaa0bd5bf2d119045aabf08bb76b.jpeg",
  galleryImageUrls: [],
  priceDollars: 155.89,
  description:
    'The Golden Mica Sphere from Oceanic Linkways Inc is a unique spiritual stone that resonates with the energy of the earth. Meticulously sourced from 19 countries, this 2-3.25" golden sphere is a product of high quality. As a premier wholesaler of gemstones and spiritual gifts, Oceanic Linkways Inc ensures quality in every product. This sphere is not just a spiritual stone but also a piece of home decor.',
  tags: [],
  msrpDollars: 311.78,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:19.271Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
